import { SelectOption } from '@indigo-ag/component-module';
import { CreditConditional } from '@indigo-ag/schema';
import i18next from 'core/i18n';
import orderBy from 'lodash/orderBy';

const TRANSLATIONS_MAP: { [key in CreditConditional]: string } = {
  REAL_ESTATE_FIDUCIARY_ALIENATION: i18next.t('creditConditionals-realEstateFiduciaryAlienation'),
  MORTGAGE: i18next.t('creditConditionals-mortgage'),
  OVERCOLLATERAL_ABOVE_130_PERCENT: i18next.t('creditConditionals-overcollateralAbove130Percent'),
  RESTRICTIONS_SETTLEMENT_BEFORE_DISBURSEMENT: i18next.t('creditConditionals-restrictionsSettlementBeforeDisbursement'),
  PREVIOUS_HARVEST_SETTLEMENT: i18next.t('creditConditionals-previousHarvestSettlement'),
  PIVOT_AREA_GUARANTEE: i18next.t('creditConditionals-pivotAreaGuarantee'),
  OWN_AREA_GUARANTEE: i18next.t('creditConditionals-ownAreaGuarantee'),
  COLLECTION_VISIT: i18next.t('creditConditionals-collectionVisit'),
  APPROVED_TRADING_CREDIT_ASSIGNMENT: i18next.t('creditConditionals-approvedTradingCreditAssignment'),
  UPDATED_REGISTRATION: i18next.t('creditConditionals-updatedRegistration'),
  OTHER: i18next.t('creditConditionals-other')
};

export const creditConditionalsTranslations = TRANSLATIONS_MAP;

const creditConditionals: SelectOption<CreditConditional>[] = Object.keys(CreditConditional).map(conditional => ({
  name: TRANSLATIONS_MAP[conditional as CreditConditional],
  value: conditional as CreditConditional
}));

export const creditConditionalsOptions: SelectOption<CreditConditional>[] = orderBy(creditConditionals, ['name']);
